import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import VSpace from "../common/VSpace"
import { faPuzzlePiece } from "@fortawesome/pro-solid-svg-icons"

type Props = {
  showDeletedView: boolean
}

const SelectTemplateView = ({showDeletedView}: Props) => {
  return <div className="overlay">
    <VSpace size="large">
      <FontAwesomeIcon icon={faPuzzlePiece} size="3x" />
      {!showDeletedView && <span>SELECT A TEMPLATE</span>}
      {showDeletedView && <div>
        <p>DELETED TEMPLATES</p>
        <p>(click on any template to restore)</p>
      </div>}
    </VSpace>
  </div>
}

export default SelectTemplateView